export default __webpack_public_path__ + "static/media/img5.4d84c72e.PNG";